// extracted by mini-css-extract-plugin
export default {"problems":"city-problems_problems__8Z0oL","problems_status":"city-problems_problems_status__G8MpP","actions":"city-problems_actions__yNx5s","tabs":"city-problems_tabs__fodhv"};